import { IRawStyle } from "@fluentui/react";
import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, ButtonRenderProps } from "sprint-common-web";

import { OnPremAudioTechnical } from "../../OnPremAssetDetails";
import {
    EditOnPremAudioAssetTechnicalAside,
    EditOnPremAudioAssetTechnicalAsideProps
} from "./edit/EditOnPremAudioTechnicalButtonAside";

interface OnPremAudioTechnicalSectionProps {
    technical: OnPremAudioTechnical;
    isLoading: boolean;
    style?: IRawStyle;
}

export const OnPremAudioTechnicalSection: React.FunctionComponent<OnPremAudioTechnicalSectionProps> = (
    props: OnPremAudioTechnicalSectionProps
) => {
    const { technical, isLoading, style } = props;

    const editTechnicalButton: ButtonRenderProps<EditOnPremAudioAssetTechnicalAsideProps> = {
        isLabeled: true,
        render: EditOnPremAudioAssetTechnicalAside
    };

    return (
        <ContentSection header="Technical" isLoading={isLoading} buttons={[editTechnicalButton]} style={style}>
            <GridRow>
                <GridColumn sm={3}>
                    <LabeledText label="Duration" testId="onprem-technical-duration" value={technical.duration} />
                    <LabeledText label="Channels" testId="onprem-technical-channels" value={technical.channelsCount} />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Bitrate"
                        testId="onprem-technical-audioBitRate"
                        value={technical.audioBitRate}
                    />
                    <LabeledText
                        label="Sample rate"
                        testId="onprem-technical-sampleRate"
                        value={technical.sampleRate}
                    />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Audio format"
                        testId="onprem-technical-audioFormat"
                        value={technical.audioFormat}
                    />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
